export enum LandingStepEnum {
  LoginStep = "LoginStep",
  VerificationStep = "VerificationStep",
  ChooseStationStep = "ChooseStationStep",
  FinishedStep = "FinishedStep",
  ErrorStep = "ErrorStep",
}
